import {
  CalculatedInternalAction,
  CalculatedInternalState,
} from 'store/aggregated/calculatedInternal';
import { domainUtility } from 'utility';

const initialState: CalculatedInternalState = { allIds: [], byId: {} };

const calculatedInternalReducer = (
  state: CalculatedInternalState = initialState,
  action: CalculatedInternalAction,
): CalculatedInternalState => {
  switch (action.type) {
    case 'aggregated/calculatedInternal/ADD':
      return domainUtility.add(state, action.payload);
    case 'aggregated/calculatedInternal/SET':
      return domainUtility.set(state, action.payload);
    case 'aggregated/calculatedInternal/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'aggregated/calculatedInternal/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'aggregated/calculatedInternal/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default calculatedInternalReducer;
